module.exports = __webpack_public_path__ + "assets/img/4.c837dd29.png";